import script from "./issue-uniform-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./issue-uniform-details.vue?vue&type=script&lang=ts&setup=true"

import "./issue-uniform-details.vue?vue&type=style&index=0&id=dac1e7bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac1e7bc"]])

export default __exports__